var _a;
import { getAllActions } from "../generic/all.actions";
import { createRoutine } from "../utils/routine.utils";
export var create = (_a = getAllActions({ entityName: "template" }), _a.create), update = _a.update, deleteObject = _a.deleteObject, getDetail = _a.getDetail, getPaged = _a.getPaged;
export var getTemplateDetail = createRoutine("TEMPLATE_DETAIL_GET");
export var updateTemplateDetail = createRoutine("TEMPLATE_DETAIL_UPDATE");
export var duplicateTemplate = createRoutine("TEMPLATE_DUPLICATE");
